import React, {useRef, useState} from 'react'
import {getPurchaseById} from "../../../services/servicePurchase";
import {useReactToPrint} from "react-to-print";
import {Button, Modal} from "antd";
import PurchasePrint from "./PurchasePrint";

const PurchasePrintContainer = ({purchaseId}) => {
    const [purchase, setPurchase] = useState([])
    const [printModal, setPrintModal] = useState(false)

    const printRef = useRef()

    const handlePrintClick = () => {
        getPurchaseById(purchaseId)
            .then(({data}) => {
                setPurchase(data)
                setPrintModal(!printModal)
            })
    }

    const handlePrintEvent = useReactToPrint({
        content: () => printRef.current
    })

    const changeModalStatus = () => setPrintModal(!printModal)


    return(
        <React.Fragment>
            <Button
                type={"link"}
                onClick={handlePrintClick}
            >
                Yazdır
            </Button>
            {
                printModal ?
                    <Modal
                        open={printModal}
                        onCancel={changeModalStatus}
                        title={'Satın Alma Ön İzleme'}
                        footer={
                            <Button
                                type={'primary'}
                                onClick={handlePrintEvent}
                            >
                                Yazdır
                            </Button>
                        }
                        bodyStyle={{
                            minWidth: '100%'
                        }}
                        style={{
                            minWidth: '85%'
                        }}
                    >
                        <PurchasePrint
                            ref={printRef}
                            purchase={purchase}
                        />
                    </Modal>
                    : null
            }
        </React.Fragment>
    )
}
export default PurchasePrintContainer